import { Accordions, FullSizeStatusLabel, DetailPanel } from '../../components/common'
import {
  clearSelectedApprovalRequest,
  stopProcessingApprovalRequest,
} from '../../actions/approvalRequests'
import { APPROVAL_REQUEST_CONFIG } from '../../constants/ApprovalRequestConstants'
import {
  selectSelectedApprovalRequest,
  selectApprovalRequestType,
  selectFilteredApprovalRequests,
} from '../../selectors/approvalRequests'
import { isEmpty } from '../../utils/common'

const mapStateToProps = (state, ownProps) => {
  const { closeFocusElem, detailPanels, requestComponent: RequestComponent } = ownProps
  const visibleApprovalRequests = selectFilteredApprovalRequests(state) || []

  return {
    approvalRequest: selectSelectedApprovalRequest(state),
    visibleApprovalRequests,
    arType: selectApprovalRequestType(state),
    RequestComponent,
    detailPanels,
    closeFocusElem,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearSelectedApprovalRequest,
      stopProcessingApprovalRequest,
    },
    dispatch
  )

class ApprovalRequestDetailPanel extends Component {
  render() {
    const {
      approvalRequest,
      visibleApprovalRequests,
      arType,
      RequestComponent,
      detailPanels,
      closeFocusElem,
      stopProcessingApprovalRequest,
      clearSelectedApprovalRequest,
    } = this.props
    let output = null

    if (!isEmpty(approvalRequest)) {
      output = (
        <DetailPanel
          title={
            <>
              <span style={{ float: 'left' }}>Approval Request</span>{' '}
              <FullSizeStatusLabel
                status={approvalRequest.etsApprovalStatus}
                alignment={{ float: 'left', marginLeft: '20px' }}
              />
            </>
          }
          onCloseAction={() => {
            stopProcessingApprovalRequest()
            clearSelectedApprovalRequest()
          }}
          closeFocusElem={closeFocusElem}
          regionLabel={`Approval request detail dialog for ${
            approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]
          }`}
          canStick={true}
          breakpointsToStick={['desktop', 'oversize']}
          triggerReStick={visibleApprovalRequests.length}
          itemId={approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]}
        >
          <>
            <RequestComponent />
            <Accordions id="requestDetailAccordions" panels={detailPanels} />
          </>
        </DetailPanel>
      )
    }

    return output
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalRequestDetailPanel)
